// #region imports

// --- Angular
import { Pipe, PipeTransform } from '@angular/core';

// --- 3rd Party
import moment from 'moment';

// #endregion

@Pipe({
  name: 'timeRemaining'
})
export class TimeRemainingPipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    if (!value) {
      return null;
    }

    if (moment(value).isBefore(moment().subtract(10, 's'))) { // ToDo: Convert magic number 10 into a constant or config supplied value
      return null;
    }

    return moment(value).toNow(true);
  }

}
